






































































































































































































































import Vue from "vue";
import HttpClientFactory from "../../../services/HttpClientFactory";
import { Select, Option } from "element-ui";
import HttpClient from "../../../services/HttpClient";
import Plan from "../../../types/invoiceSender/plan/Plan";
import { UNLIMITED } from "../../../types/invoiceSender/plan/Plan";
import PlanIndexResponse from "../../../types/invoiceSender/plan/api/PlanIndexResponse";
import ApiPlan from "../../../types/invoiceSender/plan/api/ApiPlan";
import Price from "../../../types/invoiceSender/plan/Price";

interface PlanSelectorOption {
  value: number;
  label: string;
  name: string;
  price: Price;
  includedQtyGuiSendPerMonth: number;
  includedArchiveMonths: number;
  includedEmailSupportMonth: number;
  includedLogoProfile: boolean;
  includedQtyApiSendPerMonth: number;
  includedUsers: number;
}
export default Vue.extend({
  name: "my-plan",
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  data() {
    return {
      UNLIMITED: UNLIMITED,
      httpClient: {} as HttpClient,
      changingPlan: false as boolean,
      myPlan: {
        id: 0,
        externalName: "",
        internalName: "",
        price: {
          ammount: 0,
          currency: ""
        } as Price,
        includedQtyGuiSendPerMonth: 0,
        includedArchiveMonths: 0,
        includedEmailSupportMonth: 0,
        includedLogoProfile: false,
        includedQtyApiSendPerMonth: 0,
        includedUsers: 0,
        startDate: null,
        endDate: null
      } as Plan,
      viewPlan: {
        value: 0,
        label: "",
        name: "",
        price: {
          ammount: 0,
          currency: ""
        } as Price,
        includedQtyGuiSendPerMonth: 0,
        includedArchiveMonths: 0,
        includedEmailSupportMonth: 0,
        includedLogoProfile: false as boolean,
        includedQtyApiSendPerMonth: 0,
        includedUsers: 0
      } as PlanSelectorOption | undefined,
      planSelector: {
        selectedOption: null as number | null,
        options: [] as PlanSelectorOption[]
      }
    };
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
    this.getMyPlan();
    this.getPlans();
  },
  filters: {
    monthsToYears: function(value: number) {
      return value / 12;
    }
  },
  methods: {
    getMyPlan() {
      this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/plans/v1/my-plan")
        .then((res: any) => {
          const plan: Plan = res.data;
          this.myPlan = plan;
          this.myPlan.price.ammount = this.transformToMonetaryUnit(
            plan.price.ammount
          );
          this.planSelector.selectedOption = this.myPlan.id;
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("sender:error"),
            type: "error"
          };
          this.$notify(error);
        });
    },
    updatePlan() {
      this.httpClient
        .put(process.env.VUE_APP_BACKEND_ENDPOINT + "/plans/v1/my-plan", {
          id: this.planSelector.selectedOption
        })
        .then(() => {
          const success: any = {
            text: this.$t("plan:saved"),
            type: "success"
          };
          this.$notify(success);
          this.getMyPlan();
          this.changingPlan = false;
        })
        .catch((e: any) => {
          if (e.response.status === 422) {
            const error: any = {
              text: this.$t("plan:obtained"),
              type: "error"
            };
            this.$notify(error);
          }
        });
    },
    changePlan(planId: number) {
      this.planSelector.selectedOption = planId;
      this.viewPlan = this.planSelector.options.find(
        (plan: PlanSelectorOption) => plan.value === planId
      );
    },
    transformToMonetaryUnit(number: number): number {
      return number / 10;
    },
    getPlans() {
      this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/plans/v1")
        .then((res: any) => {
          const apiPlan: PlanIndexResponse = res.data;
          this.planSelector.options = apiPlan.map((plan: ApiPlan) => {
            return {
              value: plan.id,
              label: plan.externalName,
              name: plan.internalName,
              price: plan.price,
              includedQtyGuiSendPerMonth: plan.includedQtyGuiSendPerMonth,
              includedArchiveMonths: plan.includedArchiveMonths,
              includedEmailSupportMonth: plan.includedEmailSupportMonth,
              includedLogoProfile: plan.includedLogoProfile,
              includedQtyApiSendPerMonth: plan.includedQtyApiSendPerMonth,
              includedUsers: plan.includedUsers
            };
          });
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("sender:error"),
            type: "error"
          };
          this.$notify(error);
        });
    }
  }
});
